export const getUserActivity = (user, lang, t) => {
  const date = user.lastSeen ? new Date(user.lastSeen) : null;
  const hasDate = date && !Number.isNaN(date.getTime());
  if (user.activityStatus === "recentlyActive" && hasDate) {
    return { label: t("staff_recently_active"), recent: true };
  }
  if (hasDate) {
    return {
      label: t("staff_last_active"),
      date: new Intl.DateTimeFormat(lang === "gr" ? "el-GR" : "en-GB", {
        dateStyle: "medium",
        timeStyle: "short",
      }).format(date),
    };
  }
  return {
    label: t(
      user.activityStatus === "neverConnected"
        ? "staff_never_connected"
        : "staff_activity_unknown"
    ),
  };
};

// Compare identity and club selection only: a profile refresh must not invalidate a request.
export const readActivityStorageScope = (storage) => {
  const readId = (key) => {
    try {
      return JSON.parse(storage.getItem(key))?._id || "";
    } catch (_) {
      return "invalid";
    }
  };
  return JSON.stringify([
    readId("user"),
    readId("impersonate"),
    storage.getItem("activeClubId") || "",
    storage.getItem("firebaseUid") || "",
  ]);
};
